module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "full-width"
  }, [_c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.value.title),
      expression: "value.title"
    }],
    attrs: {
      "placeholder": "Enter a title..."
    },
    domProps: {
      "value": (_vm.value.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.value, "title", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.value.subtitle),
      expression: "value.subtitle"
    }],
    attrs: {
      "placeholder": "Enter a subtitle.."
    },
    domProps: {
      "value": (_vm.value.subtitle)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.value, "subtitle", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "image-parent"
  }, [_c('img', {
    attrs: {
      "src": _vm.value.image.mobile
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "image-uploader"
  }, [_c('button', {
    staticStyle: {
      "margin-left": "10px"
    },
    on: {
      "click": _vm.changeImage
    }
  }, [_vm._v("CHANGE IMAGE")])])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.value.mediaId),
      expression: "value.mediaId"
    }],
    attrs: {
      "placeholder": "Enter a jwplayer media id.."
    },
    domProps: {
      "value": (_vm.value.mediaId)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.value, "mediaId", $event.target.value)
      }
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2f6d8a4a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/articleWidgets/videoFullWidth.vue
// module id = 639
// module chunks = 1